import * as Yup from 'yup';

export const UpdateProfileSchema = Yup.object().shape({
  fullName: Yup.string().required('Name is required')
});